import { createRecipe } from './runtime.js';

const iconConfig = {"name":"icon","defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm","xl","xs"]}}

export const icon = /* @__PURE__ */ createRecipe(iconConfig)